import {
  ADD_BOOKING_SUCCESS,
  PAST_BOOKINGS_LOADED,
  UPCOMING_BOOKINGS_LOADED,
  LOGIN_SUCCESS,
  UPDATE_DEPARTURE_TRIPID,
  UPDATE_RETURN_TRIPID,
  UPDATE_DISCOUNT_PERCENTAGE,
  UPDATE_PASSENGER_DETAIL,
  UPDATE_DPARTURETRIPS_SEATS,
  UPDATE_DPARTURETRIP_DATE,
  UPDATE_RETURNTRIP_DATE,
  UPDATE_DPARTURETRIP_REGULARID,
  UPDATE_RETURNTRIP_REGULARID,
  UPDATE_OLD_BOOKING,
  UPDATE_CURRENT_TRIP,
  RESET_BOOKING_INFO,
  SET_COMPLETEDBOOKING,
  OPERATOR_PAST_BOOKINGS_LOADED,
  OPERATOR_UPCOMING_BOOKINGS_LOADED,
  UPDATE_PACKAGEID,
  SET_PACKACCOM,
  UPDATE_RETURNTRIPS_SEATS,
} from "../actions/types";

const initialState = {
  token:
    typeof window !== "undefined" ? sessionStorage.getItem("token") : false,
  isAuthenticated: null,
  upcomingLoading: true,
  pastLoading: true,
  pastBookings: null,
  operatorPastBookings: [],
  upcomingBookings: null,
  OperatorUpcomingBookings: [],
  bookings: null,
  oldBooking: null,
  CurrentTrip: null,
  bookingInfo: {
    departureTripDate: null,
    departureTripId: null,
    departureTripAlphaId: null,
    departureTripPrice: 0,
    departureTripSeats: [],
    departureTripTime: null,
    departureTripRegularId: null,
    returnTripRegularId: null,
    returnTripId: null,
    returnTripAlphaId: null,
    returnTripPrice: 0,
    returnTripSeats: [],
    returnTripDate: null,
    discountPercentage: 0,
    passengerDetail: [],
    TravelItineraryFor: "",
    departuredate: "",
    departureTime: "Round Trip",
    departureCity: "Round Trip",
    arrivalDate: 0,
    arrivalTime: 0,
    arrivalCity: "Round Trip",
    adultCount: 1,
    operator: "",
    busId: "",
    busType: "",
    busPlateNumber: "",
    noOfSeats: "",
    seats: [],
    totalPassenger: 0,
    subtotal: 0,
    completedBooking: [],
    departureLocation: {
      lat: null,
      lng: null,
    },
    arrivalLocation: {
      lat: null,
      lng: null,
    },
    packageId: null,
    packagePricewith: 0,
    packagePricewithOut: 0,
    packagePricewithfood: 0,
    isPackage: false,
    packageAccom: "",
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      // case REGISTER_SUCCESS:
      sessionStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };

    case PAST_BOOKINGS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        pastLoading: false,
        pastBookings: payload,
      };

    case UPCOMING_BOOKINGS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        upcomingLoading: false,
        upcomingBookings: payload,
      };
    case OPERATOR_PAST_BOOKINGS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        pastLoading: false,
        operatorPastBookings: payload,
      };
    case OPERATOR_UPCOMING_BOOKINGS_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        upcomingLoading: false,
        OperatorUpcomingBookings: payload,
      };
    case ADD_BOOKING_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        bookings: payload,
      };
    // case ADD_BOOKING_SUCCESS:
    //     return {
    //         ...state,
    //         isAuthenticated: true,
    //         bookings: payload
    //     }
    case UPDATE_DEPARTURE_TRIPID:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          departureTripId: payload._id,
          departureTripPrice: payload.price,
          departureTripAlphaId: payload.tripAlphaId,
          subtotal: payload.price + (state.bookingInfo.returnTripPrice || 0),
        },
      };
    case UPDATE_RETURN_TRIPID:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          returnTripId: payload._id,
          returnTripPrice: payload.price,
          returnTripAlphaId: payload.tripAlphaId,
          subtotal: payload.price + (state.bookingInfo.departureTripPrice || 0),
        },
      };
    case UPDATE_DISCOUNT_PERCENTAGE:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          discountPercentage: payload,
        },
      };
    case UPDATE_PASSENGER_DETAIL:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          passengerDetail: payload,
        },
      };
    case UPDATE_DPARTURETRIPS_SEATS:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          departureTripSeats: payload,
        },
      };
    case UPDATE_RETURNTRIPS_SEATS:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          returnTripSeats: payload,
        },
      };
    case UPDATE_DPARTURETRIP_DATE:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          departureTripDate: payload,
        },
      };
    case UPDATE_RETURNTRIP_DATE:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          returnTripDate: payload,
        },
      };
    case UPDATE_DPARTURETRIP_REGULARID:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          departureTripRegularId: payload,
          // isPackage: true
        },
      };
    case UPDATE_RETURNTRIP_REGULARID:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          returnTripRegularId: payload,
        },
      };
    case UPDATE_OLD_BOOKING:
      return {
        ...state,
        oldBooking: payload,
      };
    case UPDATE_CURRENT_TRIP:
      return {
        ...state,
        CurrentTrip: payload,
      };
    case RESET_BOOKING_INFO:
      return {
        ...state,
        bookingInfo: initialState.bookingInfo,
      };
    case SET_COMPLETEDBOOKING:
      return {
        ...state,
        completedBooking: payload,
      };
    case UPDATE_PACKAGEID:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          packageId: payload._id,
          packagePricewith: payload.priceOptions[0]?.priceWith,
          packagePricewithOut: payload.priceOptions[1]?.priceWithout,
          packagePricewithfood: payload.priceOptions[2]?.priceWithAcomFood,
          packagePricewithVisaAccomfood:
            payload.priceOptions[3]?.priceWithVisaAcomFood,
          isPackage: true,
        },
      };
    case SET_PACKACCOM:
      return {
        ...state,
        bookingInfo: {
          ...state.bookingInfo,
          packageAccom: payload,
        },
      };
    default:
      return state;
  }
}
